var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-span-4 lg:col-span-3 place-self-center justify-self-start"
  }, [_vm.canEdit && !_vm.usedInEval ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-900",
      "bg-color": "bg-indigo-300",
      "bg-color-square": "bg-white",
      "icon-color": "text-indigo-600",
      "icon": "edit",
      "responsive": true,
      "libelle": `Modifier ${_vm.type === 'job_desc' ? 'la fiche' : 'le référentiel'}`
    },
    on: {
      "clickAction": function ($event) {
        return _vm.$emit('edit');
      }
    }
  }) : _vm.canView && _vm.usedInEval ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-900",
      "bg-color": "bg-indigo-300",
      "bg-color-square": "bg-white",
      "icon-color": "text-indigo-600",
      "icon": "edit",
      "responsive": true,
      "libelle": `Visualiser ${_vm.type === 'job_desc' ? 'la fiche' : 'le référentiel'}`
    },
    on: {
      "clickAction": function ($event) {
        return _vm.$emit('show');
      }
    }
  }) : _vm.personalLibrary && (_vm.usedInEval || !_vm.canEdit) ? _c('div', {
    on: {
      "mouseenter": function ($event) {
        _vm.evalInProgressTooltip = true;
      },
      "mouseleave": function ($event) {
        _vm.evalInProgressTooltip = false;
      }
    }
  }, [_c('div', {
    staticClass: "flex flex-col relative"
  }, [_c('div', {
    staticClass: "h-0"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "duration-300",
      "enter-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "duration-300",
      "leave-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.evalInProgressTooltip,
      expression: "evalInProgressTooltip"
    }],
    staticClass: "tooltip-Label bg-indigo-600 text-white flex absolute rounded-lg shadow-lg text-xs z-50 py-3 px-4 bottom-3 right-0 w-max-content w-max max-w-64 md:max-w-72 xl:max-w-80",
    domProps: {
      "innerHTML": _vm._s(_vm.canEdit ? 'Vous ne pouvez pas modifier ' + (_vm.type === 'job_desc' ? 'cette fiche de poste' : 'ce référentiel de formation') + ' car il y a une évaluation en cours.' : 'Vous n\'êtes pas autorisé à modifier ' + (_vm.type === 'job_desc' ? 'cette fiche de poste' : 'ce référentiel de formation'))
    }
  })])], 1)]), _vm._v(" "), _c('action-button', {
    staticClass: "cursor-not-allowed",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-600",
      "bg-color": "bg-gray-300",
      "bg-color-square": "bg-white",
      "icon-color": "text-gray-600",
      "icon": "edit",
      "responsive": true,
      "libelle": 'Modifier ' + (_vm.type === 'job_desc' ? 'la fiche' : 'le référentiel')
    }
  })], 1) : !_vm.personalLibrary && _vm.canImport && !_vm.disabled ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-900",
      "bg-color": "bg-indigo-300",
      "bg-color-square": "bg-white",
      "icon-color": "text-indigo-600",
      "icon": "plus",
      "responsive": true,
      "libelle": "Ajouter à ma bibliothèque"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.$emit('import');
      }
    }
  }) : !_vm.personalLibrary && _vm.canImport && _vm.disabled ? _c('action-button', {
    staticClass: "cursor-not-allowed",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-600",
      "bg-color": "bg-gray-300",
      "bg-color-square": "bg-white",
      "icon-color": "text-gray-600",
      "icon": "plus",
      "responsive": true,
      "libelle": "Ajouter à ma bibliothèque"
    }
  }) : !_vm.personalLibrary && !_vm.canImport ? _c('div', {
    on: {
      "mouseenter": function ($event) {
        _vm.notEnoughRightsTooltip = true;
      },
      "mouseleave": function ($event) {
        _vm.notEnoughRightsTooltip = false;
      }
    }
  }, [_c('div', {
    staticClass: "flex flex-col relative"
  }, [_c('div', {
    staticClass: "h-0"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "duration-300",
      "enter-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "duration-300",
      "leave-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.notEnoughRightsTooltip,
      expression: "notEnoughRightsTooltip"
    }],
    staticClass: "tooltip-Label bg-indigo-600 text-white flex absolute rounded-lg shadow-lg text-xs z-50 py-3 px-4 bottom-3 right-0 w-max-content w-max max-w-64 md:max-w-72 xl:max-w-80",
    domProps: {
      "innerHTML": _vm._s('Vous n\'êtes pas autorisé à ajouter ' + (_vm.type === 'job_desc' ? 'une fiche de poste' : 'un référentiel de formation') + ' dans la bibliothèque personnelle')
    }
  })])], 1)]), _vm._v(" "), _c('action-button', {
    staticClass: "cursor-not-allowed",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-600",
      "bg-color": "bg-gray-300",
      "bg-color-square": "bg-white",
      "icon-color": "text-gray-600",
      "icon": "plus",
      "responsive": true,
      "libelle": "Ajouter à ma bibliothèque"
    }
  })], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }